import { derived, writable } from 'svelte/store';
import 'unfetch/polyfill';

export const availabilityData = writable({});
export const availabilityLocationTypes = writable([]);

export const availabilityTotalNights = derived(
  [availabilityData],
  ([$availabilityData]) => $availabilityData.TotalNights
);

export const fetchStates = {
  IDLE: 'idle',
  REQUEST: 'loading',
  LOADING: {
    RESOLVE: 'success',
    REJECT: 'failure',
  },
};

export const isFetchingAvailability = writable(fetchStates.IDLE);

export const isIdleAvailabilityData = derived(
  isFetchingAvailability,
  ($isFetchingAvailabilityStates) =>
    $isFetchingAvailabilityStates === fetchStates.IDLE
);

export const isLoadingAvailabilityData = derived(
  isFetchingAvailability,
  ($isFetchingAvailabilityStates) =>
    $isFetchingAvailabilityStates === fetchStates.REQUEST
);

export const isResolvedAvailabilityData = derived(
  isFetchingAvailability,
  ($isFetchingAvailabilityStates) =>
    $isFetchingAvailabilityStates === fetchStates.LOADING.RESOLVE
);

export const isRejectedAvailabilityData = derived(
  isFetchingAvailability,
  ($isFetchingAvailabilityStates) =>
    $isFetchingAvailabilityStates === fetchStates.LOADING.REJECT
);

/**
 * @author Dat Doan
 * @date 2021-03-09
 * @param {string} queryString
 * @returns {object}
 */
export async function getAvailabilityList(queryString) {
  // Bail when param is not empty
  if (!queryString) {
    return;
  }
  isFetchingAvailability.set(fetchStates.REQUEST);
  availabilityData.set({});
  availabilityLocationTypes.set([]);
  const hostname = '//' + location.hostname;
  const endpointPath = '/npws/ReservationApi/DetailedAvailability?';
  try {
    const response = await fetch(hostname + endpointPath + queryString);
    const data = await response.json();
    if (data.hasOwnProperty('LocationTypes')) {
      availabilityLocationTypes.set(data.LocationTypes);
    }
    availabilityData.set(data);
    isFetchingAvailability.set(fetchStates.LOADING.RESOLVE);
  } catch (error) {
    isFetchingAvailability.set(fetchStates.LOADING.REJECT);
    console.warn(`Request issue ${error}`);
  }
}
